type PlayerZoneConfig = {
  api_key: string;
  ad_unit_path: string;
  ad_targeting: Record<string, unknown>;
  ga_category?: string;
  hide_newsletter?: boolean;
  hide_advertising?: boolean;
  hide_chrome?: boolean;
  player_modes?: string[];
};

type ValidZones = {
  [key: string]: PlayerZoneConfig;
};

const VALID_ZONES: ValidZones = {
  talks: {
    api_key: 'talk_page_2',
    ad_unit_path: 'talk',
    ad_targeting: {}
  },
  playlists: {
    api_key: 'playlist_page_2',
    ad_unit_path: 'playlists',
    ad_targeting: {}
  },
  embed_talks: {
    api_key: 'embed2',
    ad_unit_path: 'embed/talk',
    ad_targeting: {}
  },
  embed_playlists: {
    api_key: 'embed2',
    ad_unit_path: 'embed/playlist',
    ad_targeting: {}
  },
  audacious_project: {
    api_key: 'embed2',
    ad_unit_path: 'embed/talk',
    ad_targeting: {},
    hide_chrome: true
  },
  countdown: {
    api_key: 'embed2',
    ad_unit_path: 'embed/talk',
    ad_targeting: {},
    hide_chrome: true
  },
  recommends_home: {
    api_key: 'talk_page_2',
    ad_unit_path: 'talk',
    ad_targeting: {},
    hide_chrome: true
  },
  tedatwork: {
    api_key: 'tedatwork',
    ad_unit_path: 'embed/talk',
    ad_targeting: {},
    hide_advertising: true,
    hide_newsletter: true
  },

  // partner zones
  huffpost: {
    api_key: 'huffpost',
    ad_unit_path: 'embed/huffpost',
    ad_targeting: {}
  },
  wiley: {
    api_key: 'wiley',
    ad_unit_path: 'embed/talk',
    ad_targeting: {}
  },
  mashable: {
    api_key: 'mashable',
    ad_unit_path: 'embed/talk',
    ad_targeting: {}
  },
  rthk: {
    api_key: 'rthk',
    ad_unit_path: 'embed/rthk',
    ad_targeting: {}
  },
  aceup: {
    api_key: 'aceup',
    ad_unit_path: 'embed/talk',
    ad_targeting: {},
    hide_advertising: true,
    hide_newsletter: true
  },
  npr2: {
    api_key: 'npr2',
    ad_unit_path: 'embed/npr',
    ad_targeting: {}
  },
  ndtv: {
    api_key: 'ndtv',
    ad_unit_path: 'embed/talk',
    ad_targeting: {}
  },
  netease: {
    api_key: 'netease',
    ad_unit_path: 'embed/talk',
    ad_targeting: {}
  },
  skype: {
    api_key: 'skype',
    ad_unit_path: 'embed/talk',
    ad_targeting: {}
  },
  smh: {
    api_key: 'smh',
    ad_unit_path: 'embed/talk',
    ad_targeting: {}
  },
  chevyhuff: {
    api_key: 'chevyhuff',
    ad_unit_path: 'embed/huffpost',
    ad_targeting: {}
  },
  si: {
    api_key: 'superinteressante',
    ad_unit_path: 'embed/talk',
    ad_targeting: {}
  },
  yahoojapan: {
    api_key: 'yahoojapan',
    ad_unit_path: 'embed/yahoojapan',
    ad_targeting: {}
  },
  rtve: {
    api_key: 'rtve',
    ad_unit_path: 'embed/talk',
    ad_targeting: {}
  },
  sciam: {
    api_key: 'sciam',
    ad_unit_path: 'embed/sciam',
    ad_targeting: {}
  },
  nhk: {
    api_key: 'nhk',
    ad_unit_path: 'embed/talk',
    ad_targeting: {}
  },
  forbes: {
    api_key: 'forbes',
    ad_unit_path: 'embed/forbes',
    ad_targeting: {}
  },
  viacom: {
    api_key: 'viacom',
    ad_unit_path: 'embed/talk',
    ad_targeting: {}
  },
  hsbc: {
    api_key: 'HSBC',
    ad_unit_path: 'embed/hsbc',
    ad_targeting: {}
  },
  kia: {
    api_key: 'kia',
    ad_unit_path: 'embed/kia',
    ad_targeting: {}
  },
  lingualeo: {
    api_key: 'lingualeo',
    ad_unit_path: 'embed/talk',
    ad_targeting: {}
  },
  mazda: {
    api_key: 'mazda',
    ad_unit_path: 'embed/mazda',
    ad_targeting: {}
  },
  upworthy: {
    api_key: 'upworthy',
    ad_unit_path: 'embed/upworthy',
    ad_targeting: {}
  },
  huffpostuk: {
    api_key: 'huffpost_uk',
    ad_unit_path: 'embed/talk',
    ad_targeting: {}
  },
  cnn: {
    api_key: 'cnn',
    ad_unit_path: 'embed/talk',
    ad_targeting: {}
  },
  prudential: {
    api_key: 'prudential',
    ad_unit_path: 'embed/prudential',
    ad_targeting: {}
  },
  ptt: {
    api_key: 'ptt',
    ad_unit_path: 'embed/ptt',
    ad_targeting: {}
  },
  ozy: {
    api_key: 'ozy',
    ad_unit_path: 'embed/talk',
    ad_targeting: {}
  },
  tencent: {
    api_key: 'tencent',
    ad_unit_path: 'embed/talk',
    ad_targeting: {}
  },
  teva: {
    api_key: 'teva',
    ad_unit_path: 'embed/talk',
    ad_targeting: {},
    hide_advertising: true,
    hide_newsletter: true
  },
  success: {
    api_key: 'success',
    ad_unit_path: 'embed/talk',
    ad_targeting: { partner: 'success' }
  },
  cornerstone: {
    api_key: 'cornerstone',
    ad_unit_path: 'embed/talk',
    ad_targeting: { partner: 'cornerstone' },
    hide_newsletter: true,
    player_modes: ['hls', 'hlsjs', 'h264']
  },
  apds: {
    api_key: 'apds',
    ad_unit_path: 'embed/talk',
    ad_targeting: { partner: 'apds' },
    hide_newsletter: true
  },
  nokia: {
    api_key: 'nokia',
    ad_unit_path: 'embed/talk',
    ad_targeting: { partner: 'nokia' },
    hide_newsletter: true
  },
  usalearning: {
    api_key: 'usalearning',
    ad_unit_path: 'embed/talk',
    ad_targeting: {},
    hide_advertising: true,
    hide_newsletter: true
  },
  viking: {
    api_key: 'viking',
    ad_unit_path: 'embed/talk',
    ad_targeting: {},
    hide_advertising: true,
    hide_newsletter: true
  },
  ubits: {
    api_key: 'ubits',
    ad_unit_path: 'embed/talk',
    ad_targeting: {},
    hide_advertising: true,
    hide_newsletter: true
  },
  blueoceanbrain: {
    api_key: 'blueoceanbrain',
    ad_unit_path: 'embed/talk',
    ad_targeting: {},
    hide_advertising: true,
    hide_newsletter: true
  },

  // Speaker zones: some speakers want to display their talk on a
  // personal site without ads etc. for privacy/legal reasons.
  // Cesar Kuriyama: under legal advice Re CCPA - 2020-01-22 Joe
  onesec: {
    api_key: 'embed2',
    ad_unit_path: 'embed/talk',
    ad_targeting: {},
    hide_advertising: true
  },

  // test zone: do not remove this zone
  test: {
    api_key: 'test',
    ad_unit_path: 'embed/test',
    // ad_targeting will be passed to GPT using setTargeting()
    // see https://support.google.com/dfp_premium/answer/1697712?hl=en
    ad_targeting: { topic: 'science' }
  }
};

function getPlayerZone(zoneName: string): PlayerZoneConfig | undefined {
  if (!zoneName) return;

  const zoneKey = zoneName.toLowerCase();
  return VALID_ZONES[zoneKey];
}

function isValidZone(zoneName: string): boolean {
  if (!zoneName) return false;

  const zoneKey = zoneName.toLowerCase();
  return VALID_ZONES.hasOwnProperty(zoneKey);
}

export { getPlayerZone, isValidZone, type PlayerZoneConfig };
